import { Component, ViewChild } from '@angular/core';
import { ClinicPub } from '../../../core/models/clinic-pub.model';
import {
  DATA_SERVICE_TOKEN,
  EoSearchPageComponent,
  SearchPageOptionsService,
  STATUS,
} from 'ngx-eo-web-components';
import { ClinicService } from '../../../../services/clinic/clinic.service';
import { ClinicFormDialogComponent } from '../clinic-form-dialog/clinic-form-dialog.component';
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { Clinic } from '../../../core/models/clinic.model';
import { ClinicsTableConfigBuilder } from '../../config/clinic-search.config';
import { clinicSearchFormConfig } from '../../config/clinic-search-form.config';
import { CoreService } from '../../../core/core.service';

@Component({
  selector: 'app-clinic-search',
  templateUrl: './clinic-search.component.html',
  styleUrl: './clinic-search.component.scss',
  providers: [
    SearchPageOptionsService,
    { provide: DATA_SERVICE_TOKEN, useClass: ClinicService },
  ],
})
export class ClinicSearchComponent extends EoSearchPageComponent<ClinicPub> {
  @ViewChild('clinicFormDialog', { static: false })
  clinicFormDialog?: ClinicFormDialogComponent;

  data$ = new BehaviorSubject<Clinic[]>([]);
  override tableConfig = this.getClinicTableConfig();

  protected getClinicTableConfig() {
    let data = this.searchService.searchCh.data$.getValue()?.resultset ?? [];
    return new ClinicsTableConfigBuilder()
      .addFunction('onEditClinic', this.onEditClinic.bind(this))
      .addFunction('onCreateClinic', this.onCreateClinic.bind(this))
      .addClinicDeleteFunction(this.onDeleteClinic.bind(this))
      .getTable(data);
  }

  override defaultSearchParam = {
    HospitalID: null,
    SortParams: null,
  };

  override searchParam = { ...this.defaultSearchParam };
  override formConfig = clinicSearchFormConfig;

  constructor(
    override searchService: ClinicService,
    private coreService: CoreService
  ) {
    super(searchService);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.searchService.searchCh.data$.subscribe(() => {
      if (this.tableConfig) {
        this.tableConfig = this.getClinicTableConfig();
      }
    });
  }

  onEditClinic(item: any) {
    this.clinicFormDialog?.show(item);
  }

  onCreateClinic() {
    const item = new Clinic();
    this.clinicFormDialog?.show();
  }

  override isLoading(): boolean {
    return (
      this.searchService.searchCh.status$.getValue() === STATUS.loading ||
      this.searchService.clinicDeleteCallHandler.status$.getValue() ===
        STATUS.loading
    );
  }

  onDeleteClinic(clinicId: string, event?: any): void {
    this.confirmationService.confirm({
      target: event.target,
      header: 'ΠΡΟΣΟΧΗ!',
      message: `Είστε σίγουροι ότι θέλετε να διαγράψετε τη συγκεκριμένη κλινική; Η ενέργεια είναι αμετάκλητη.`,
      rejectLabel: 'Όχι',
      closeOnEscape: false,
      icon: 'pi pi-exclamation-triangle p-warning',
      acceptLabel: 'Ναι',
      rejectVisible: true,
      rejectButtonStyleClass: 'p-button-text',
      key: 'deleteClinicPopup',
      accept: () => {
        return this.searchService
          .deleteClinic(clinicId)
          .subscribe(() => this.onClinicDeleteSuccess());
      },
    });
  }

  private onClinicDeleteSuccess() {
    this.showDeleteSuccessMessage();
    this.onSearch();
  }

  showDeleteSuccessMessage(): void {
    this.coreService.showSuccess('Η κλινική διαγράφηκε με επιτυχία');
  }

  onClinicFormSuccess() {
    this.onSearch();
  }

  onSearch(searchParams?: any) {
    if (searchParams) this.searchParam = searchParams?.form;

    this.searchService
      .searchClinics(this.searchParam, this.getPagesize(), this.getPage())
      .subscribe();
  }

  override getTotalCount(): number {
    return this.searchService.searchCh.data$.getValue()?.totalCount ?? 0;
  }
}
